import { callZpayFunction } from '../../callZpayFunction';

// 현재 브라우저 닫기
export const close = () => {
  callZpayFunction('close')();
};
